module.exports = __webpack_public_path__ + "static/media/icon-circle-grey.67863d4a.svg";